import React from "react";
import Icon from "./Icon";
import type { IconProps } from "./IconProps";

const SparkleIcon: React.FC<IconProps> = ({ className, title }) => {
  const svgPath = (
    <path
      d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 2l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 6 6.5 11.5 1 14l5.5 2.5L9 22l2.5-5.5L17 14l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z"
    />
  );

  return (
    <Icon
      svgPath={svgPath}
      className={className}
      title={title}
      viewBox="0 0 24 24"
      fill="currentColor"
      stroke="none"
    />
  );
};

export default SparkleIcon;
